const initialState = {
    sidebarShow: true,
    theme: 'light',
  }
  export const stateReducer = (state = initialState, { type, ...rest }) => {
    switch (type) {
      case 'set':
        return { ...state, ...rest }
      default:
        return state
    }
  }
  